import { EditJobsiteTemplateFormData } from './types';

export { getFormInputs, getAsNumber } from './EditJobsiteTemplateModal.forms';

export const getDefaultValues = (): EditJobsiteTemplateFormData => ({
  name: '',
  developerId: null,
});
